import { render, staticRenderFns } from "./AcquisitionPage.vue?vue&type=template&id=0e18be9c&"
import script from "./AcquisitionPage.vue?vue&type=script&lang=js&"
export * from "./AcquisitionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports